import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f200f48e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-common" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-prev-btn-hover" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  class: "tab-common-container",
  ref: "tabCommonContainerRef"
}
const _hoisted_5 = {
  class: "tab-common-main",
  ref: "tabCommonMainRef"
}
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "tab-text title-text" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-next-btn-hover" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", {
      class: "left tab-common-btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tabMobileScrollHandler('left')))
    }, _hoisted_3, 512), [
      [_vShow, _ctx.tabMobileScroll > 0]
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lists, (list) => {
          return (_openBlock(), _createElementBlock("label", {
            key: list.value,
            class: "tab-common-list"
          }, [
            (list.value === 'crossTransfer')
              ? _renderSlot(_ctx.$slots, "prep", { key: 0 }, undefined, true)
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              value: list.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.setActive) = $event)),
              hidden: ""
            }, null, 8, _hoisted_6), [
              [_vModelRadio, _ctx.setActive]
            ]),
            _createElementVNode("p", _hoisted_7, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(list.value === _ctx.active ? 'strong' : 'p'), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(list.name || _ctx.$t(`common.components.tab.name.${list.value}`)), 1)
                ]),
                _: 2
              }, 1024))
            ])
          ]))
        }), 128)),
        _createElementVNode("div", {
          class: "slider",
          style: _normalizeStyle(_ctx.setSliderStyle)
        }, null, 4)
      ], 512)
    ], 512),
    _withDirectives(_createElementVNode("div", {
      class: "right tab-common-btn",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tabMobileScrollHandler('right')))
    }, _hoisted_9, 512), [
      [_vShow, _ctx.tabMobileScroll < _ctx.tabMobileScrollMax]
    ])
  ]))
}